const SupemboutsAvatarIcon = () => {
	return (
		<svg
			width="26"
			height="28"
			viewBox="0 0 26 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g filter="url(#filter0_d_9953_53639)">
				<title>supembouts avatar icon</title>
				<rect
					x="2"
					y="1"
					width="21.9911"
					height="24"
					rx="10.9956"
					fill="white"
					shapeRendering="crispEdges"
				/>
				<rect
					x="2.5"
					y="1.5"
					width="20.9911"
					height="23"
					rx="10.4956"
					stroke="#F1F5F9"
					shapeRendering="crispEdges"
				/>
				<g clip-path="url(#clip0_9953_53639)">
					<path
						d="M11.3409 17.0512C12.0982 17.0512 12.8554 17.0553 13.6126 17.0496C14.0503 17.0463 14.4811 16.9895 14.8751 16.7802C15.5324 16.4308 15.9213 15.8883 16.0358 15.15C16.1068 14.6914 16.0952 14.2337 15.9395 13.798C15.6367 12.9509 15.0283 12.4477 14.1381 12.3038C13.656 12.226 13.1673 12.261 12.6812 12.2551C12.5241 12.2531 12.3712 12.2293 12.2236 12.1752C11.9181 12.0633 11.7347 11.8468 11.6703 11.5285C11.6304 11.3319 11.636 11.1363 11.7001 10.946C11.8214 10.5865 12.1033 10.4288 12.4547 10.3964C12.9202 10.3532 13.3882 10.3699 13.8554 10.3882C14.2827 10.4049 14.7038 10.4616 15.1172 10.5732C15.6421 10.7148 16.1355 10.9185 16.5563 11.2754C17.1029 11.7393 17.4687 12.3227 17.701 12.9942C17.8601 13.454 17.9451 13.9276 17.9679 14.4143C18.0095 15.3029 17.8583 16.1524 17.4483 16.9451C16.9997 17.8125 16.3203 18.4109 15.3739 18.7003C14.8282 18.8671 14.274 18.9552 13.7052 18.9654C12.1662 18.9924 10.6272 18.9747 9.08815 18.9734C8.8941 18.9732 8.70069 18.9563 8.51746 18.8801C8.28289 18.7825 8.12459 18.6145 8.05356 18.3714C7.9786 18.1143 7.98418 17.8561 8.08982 17.6088C8.23581 17.2669 8.52025 17.1135 8.87326 17.0689C9.15081 17.0338 9.43034 17.0548 9.70887 17.053C10.2528 17.0492 10.7969 17.0519 11.341 17.0519V17.0512H11.3409Z"
						fill="#1444E1"
					/>
					<path
						d="M13.5858 7.00047C13.9959 7.00047 14.4058 6.99899 14.8159 7.00129C14.9496 7.00194 15.0831 7.01244 15.2144 7.04328C15.6087 7.13596 15.8485 7.41237 15.8787 7.81574C15.8973 8.06425 15.8615 8.30342 15.7153 8.51224C15.5529 8.74452 15.3152 8.85032 15.0426 8.89199C14.9176 8.91102 14.792 8.90839 14.6663 8.90856C13.9145 8.90905 13.1627 8.90511 12.411 8.91085C12.0276 8.91381 11.6451 8.94284 11.2858 9.09457C10.5076 9.42331 10.0504 10.0025 9.92332 10.8424C9.85278 11.3079 9.87099 11.7702 10.0345 12.2078C10.3467 13.0433 10.96 13.5367 11.8432 13.6712C12.1908 13.7242 12.5451 13.7167 12.8977 13.7155C13.1504 13.7147 13.4057 13.7014 13.6552 13.77C14.0402 13.8758 14.2751 14.1592 14.3084 14.5588C14.3261 14.7706 14.3051 14.9747 14.1993 15.1618C14.0497 15.4268 13.8007 15.5418 13.5143 15.5652C13.0346 15.6044 12.5533 15.5916 12.0727 15.5713C11.6592 15.5539 11.2519 15.4968 10.8521 15.3884C10.3521 15.2527 9.8787 15.0626 9.47058 14.7322C8.91285 14.2808 8.53851 13.7032 8.29574 13.0349C8.13153 12.5827 8.04099 12.1157 8.01146 11.635C7.95536 10.7241 8.10217 9.85227 8.52014 9.03733C8.94401 8.21041 9.58097 7.61676 10.4724 7.31444C11.0253 7.1271 11.5927 7.03163 12.1757 7.00965C12.6459 6.99194 13.1158 7.00637 13.5858 7.0003V7.00047Z"
						fill="#1444E1"
					/>
				</g>
			</g>
			<defs>
				<filter
					id="filter0_d_9953_53639"
					x="0"
					y="0"
					width="25.9911"
					height="28"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="1" />
					<feGaussianBlur stdDeviation="1" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_9953_53639"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_9953_53639"
						result="shape"
					/>
				</filter>
				<clipPath id="clip0_9953_53639">
					<rect
						width="9.99112"
						height="12"
						fill="white"
						transform="translate(8 7)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default SupemboutsAvatarIcon;
